<template>
<div id="irecord">
    <headernav type="irecord"></headernav>
    <div class="content">
        <!-- <elmenu type="sellment"></elmenu> -->
        <router-view></router-view>
    </div>
</div>
</template>

<script type="text/javascript">
import headernav from '../inavmenu/headernav.vue'
import elmenu from '../inavmenu/elmenu.vue'
import '../../static/style/irecord/index.scss'

export default {
    data() {
        return {

        }
    },
    components: {
        headernav,
        elmenu
    }
}
</script>



// WEBPACK FOOTER //
// index.vue?b1897ba0